import {createReducer} from '@reduxjs/toolkit';

import {getQuote, removeQuoteItem} from '../../reducers/quoteItems/quoteItems';
import {addAccessory} from '../accessories/accessories';

type CartStatusType = 'fulfilled' | 'rejected' | 'pending' | '';

/**
 * Cart status reducer
 */
export const cartStatus = createReducer<CartStatusType>('', builder =>
    builder
        .addCase(getQuote.fulfilled, () => 'fulfilled')
        .addCase(removeQuoteItem.fulfilled, () => 'fulfilled')
        .addCase(addAccessory.fulfilled, () => 'fulfilled')
        .addCase(getQuote.pending, () => 'pending')
        .addCase(removeQuoteItem.pending, () => 'pending')
        .addCase(addAccessory.pending, () => 'pending')
        .addCase(getQuote.rejected, () => 'rejected')
        .addCase(removeQuoteItem.rejected, () => 'rejected'),
);
